/**
 * Risoluzione della lingua iniziale dell'app.
 * Lingue supportate: 'it' (default contenutistico) e 'en' (fallback per tutto il resto).
 */
export const SUPPORTED_LOCALES = ['it', 'en'];

/**
 * Funzione pura e testabile.
 * @param {string|null|undefined} storedPreference - valore di localStorage 'preferredLanguage'
 * @param {string|null|undefined} navigatorLanguage - es. navigator.language ('it-IT', 'en-US', ...)
 * @returns {'it'|'en'}
 */
export function resolveInitialLocale(storedPreference, navigatorLanguage) {
  if (SUPPORTED_LOCALES.includes(storedPreference)) {
    return storedPreference;
  }
  if (typeof navigatorLanguage === 'string' && navigatorLanguage.toLowerCase().startsWith('it')) {
    return 'it';
  }
  return 'en';
}

/**
 * Helper che legge dall'ambiente browser. Usato a runtime (i18n, Clerk).
 * @returns {'it'|'en'}
 */
export function getInitialLocale() {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('preferredLanguage') : null;
  const navLang = typeof navigator !== 'undefined' ? navigator.language : null;
  return resolveInitialLocale(stored, navLang);
}
